import Store from '@/store'
import firebase from "firebase";

export class PermissionsStoreUtils {

    /*

{id: '1', name: '/*'}

++ {id: '2', name: '/api/v1/getUserData'}

++ {id: '3', name: '/api/v1/getLocaleKeys'}

++ {id: '6', name: '/api/v1/getMaps'}
++ {id: '9', name: '/api/v1/getMap'}
++ {id: '8', name: '/api/v1/duplicateMap'}
++ {id: '10', name: '/api/v1/removeMap'}
++ {id: '13', name: '/api/v1/setMapAudience'}
++ {id: '14', name: '/api/v1/setMapClientVersion'}
++ {id: '18', name: '/api/v1/uploadMap'}

{id: '22', name: '/api/v1/updateABTest'}
{id: '21', name: '/api/v1/newABTest'}
{id: '24', name: '/api/v1/setABTestActive'}
{id: '25', name: '/api/v1/deleteABTest'}
{id: '23', name: '/api/v1/getABTestList'}

{id: '4', name: '/api/v1/getConfigs'}
{id: '5', name: '/api/v1/removeConfig'}
{id: '11', name: '/api/v1/setConfigAudience'}
{id: '12', name: '/api/v1/setConfigClientVersion'}
{id: '17', name: '/api/v1/uploadConfig'}

++ {id: '30', name: '/api/v1/getUsersCountPerApp'}
++ {id: '31', name: '/api/v1/removeUsersCountPerApp'}

++ {id: '27', name: '/api/v1/getLastAssetUploadResult'}

++ {id: '16', name: '/api/v1/getUserSave'}
++ {id: '15', name: '/api/v1/setUserAudience'}

++ {id: '19', name: '/api/v1/uploadLocales'}
++ {id: '26', name: '/api/v1/crossDeploy'}
++ {id: '28', name: '/api/v1/getAssetCacheInfo'}
++ {id: '29', name: '/api/v1/cacheAssets'}

{id: '32', name: '/api/v1/getRegisteredApi'}
{id: '34', name: '/api/v1/getUsersPermission'}

++ {id: '33', name: '/api/v1/setUserPermission'}

++ {id: '35', name: '/api/v1/removeLocaleKeys'}
++ {id: '36', name: '/api/v1/createUserSnapshot'}


    * */


    //https://www.345tool.com/generator/random-id-generator

    static AB_TAB = {
        name: 'A/B Testing',
        message: "Allow to view A/B Testing Tab",
        id: "ex5Nip0poK",
        api: [21, 22, 23, 24, 25],
        subpermissions: {}
    };

    static CACHE_TAB = {
        name: 'Cache',
        message: "Allow to view Cache Tab",
        id: "if1I2d9NqY",
        api: [28, 29],
        subpermissions: {}
    };

    //
    static CONFIG_TAB = {
        name: 'Configs',
        message: "Allow to view Configs Tab",
        id: "CwNuuQIgxi",
        api: [4, 17],
        subpermissions: {
            CONFIG_TAB_VIEW_MY_CONFIGS: {
                name: 'View My Config',
                message: "Allow to view My Configs",
                id: "UdKH54mNly",
                api: [],
            },
            CONFIG_TAB_VIEW_PRERELEASE: {
                name: 'View Pre Relase',
                message: "Allow to view Pre Relase",
                id: "1kLu2QRDWf",
                api: [],
            },
            CONFIG_TAB_VIEW_RELEASE: {
                name: 'View Relase',
                message: "Allow to view Relase",
                id: "qWnARHHuWU",
                api: [],
            },
            //MY CONFIGS
            CONFIG_TAB_MC_EDIT: {
                name: '(MC) Edit My Config',
                message: "Allow to edit My Configs",
                id: "YGeesCeXkK",
                api: [],
            },
            CONFIG_TAB_MC_DELETE: {
                name: '(MC) Delete My Config',
                message: "Allow to delete My Configs",
                id: "B6czWk5z66",
                api: [],
            },
            CONFIG_TAB_MC_DUBLICATE: {
                name: '(MC) Dublicate My Config',
                message: "Allow to dublicate My Configs",
                id: "pDUx2AYonV",
                api: [],
            },
            CONFIG_TAB_MC_MERGE: {
                name: '(MC) Merge My Config',
                message: "Allow to merge My Configs",
                id: "37cefZ6Nf0",
                api: [],
            },
            CONFIG_TAB_MC_DEPLOY: {
                name: '(MC) Deploy My Config',
                message: "Allow to deploy My Configs",
                id: "77ubPZe6LT",
                api: [],
            },
            CONFIG_TAB_MC_EDIT_NAME: {
                name: '(MC) Edit name My Config',
                message: "Allow to edit name My Configs",
                id: "y0rm3qIDgG",
                api: [],
            },
            CONFIG_TAB_MY_SET_INFO: {
                name: '(PRE) Set Info',
                message: "Allow to set info to config",
                id: "5nJCf8PyDZ",
                api: [51],
            },
            //PRERELEASE
            CONFIG_TAB_PRE_EDIT_TAG: {
                name: '(PRE) Edit Tag Config',
                message: "Allow to edot pre release config tag",
                id: "k4A24KfdOi",
                api: [],
            },
            CONFIG_TAB_PRE_COPY_TO_MY: {
                name: '(PRE) Copy to My Config',
                message: "Allow to copy fom Pre Release to My Configs",
                id: "SfI0bC0Avq",
                api: [],
            },
            CONFIG_TAB_PRE_DEPLOY_TO_STORAGE: {
                name: '(PRE) Deploy Config',
                message: "Allow to deploy config to storage",
                id: "jm3QKZRJex",
                api: [],
            },
            CONFIG_TAB_PRE_SET_INFO: {
                name: '(PRE) Set Info',
                message: "Allow to set info to config",
                id: "yOkTwxJP2Z",
                api: [51],
            },
            //RELEASE
            CONFIG_TAB_RE_EDIT_AUDIENCE: {
                name: '(RE) Edit Audiences',
                message: "Allow to edit audiences in release config",
                id: "tSwB1mTYnA",
                api: [11],
            },
            CONFIG_TAB_RE_EDIT_VERSION: {
                name: '(RE) Edit Version',
                message: "Allow to edit version in release config",
                id: "e4wztIrdCW",
                api: [12],
            },
            CONFIG_TAB_RE_DELETE: {
                name: '(RE) Delete config',
                message: "Allow to delete release config",
                id: "GF4G7U8nXG",
                api: [5],
            },
            CONFIG_TAB_RE_SET_INFO: {
                name: '(PRE) Set Info',
                message: "Allow to set info to config",
                id: "9xZkvKZpdf",
                api: [51],
            },
            CONFIG_TAB_RE_EXPORT: {
                name: '(PRE) Export Config',
                message: "Allow to export config",
                id: "T2HuZvJYS5",
                api: [53],
            },
            CONFIG_TAB_RE_SET_MASTER: {
                name: '(PRE) Set Master',
                message: "Allow to set master to config",
                id: "w8OliAF3Cx",
                api: [52],
            },
            CONFIG_TAB_MASTER_CONFIGS: {
                name: 'View Master Configs',
                message: "Allow to view master config tab",
                id: "9pNWx1DYcF",
                api: [],
            },
            CONFIG_TAB_MERGE_HISTORY: {
                name: 'View Merge History',
                message: "Allow to view merge history tab",
                id: "OTf6qG9495",
                api: [],
            },
        }
    };

    static DEPLOY_TAB = {
        name: 'Deploy',
        message: "Allow to view Deploy Tab",
        id: "FfXgrBTIWG",
        api: [26, 27],
        subpermissions: {
            DEPLOY_TAB_ADD_MAP_TO_DEPLOY: {
                name: 'Deploy map',
                message: "Allow to deploy map in cache (from map tab)",
                id: "GBSVOpQSea",
                api: [],
            },
            DEPLOY_TAB_ADD_CONFIG_TO_DEPLOY: {
                name: 'Deploy config',
                message: "Allow to deploy config in cache  (from config release tab)",
                id: "8vKpTRoYP2",
                api: [],
            },
            DEPLOY_TAB_ADD_PACKAGE_TO_DEPLOY: {
                name: 'Deploy package',
                message: "Allow to deploy package in cache  (from package active tab)",
                id: "ww5wWKv59H",
                api: [],
            },
            DEPLOY_TAB_DEPLOY_TO_NEXT: {
                name: 'Deploy to next environment',
                message: "Allow to deploy to next environment",
                id: "4uhs9PXxoh",
                api: [],
            },
        }
    };

    static INBOX_TAB = {
        name: 'Inbox',
        message: "Allow to view Inbox Tab",
        id: "UyxO70HQo8",
        api: [],
        subpermissions: {
            INBOX_TAB_DELETE: {
                name: 'Delete inbox message',
                message: "Allow to delete inbox message",
                id: "hwjD3ryUGN",
                api: [],
            },
        }
    };

    static INFO_TAB = {
        name: 'Info Tab',
        message: "Allow to view Info Tab",
        id: "WXmzeKOdNa",
        api: [30, 31, 49],
        subpermissions: {
            // INFO_TAB_DELETE:{
            //     name:'Delete version info',
            //     message:"Allow to delete version info",
            //     id:"CoBbUrJYqR",
            //     api:[31],
            // },
        }
    };

    static LOCALIZATION_TAB = {
        name: 'Localization',
        message: "Allow to view Localization Tab",
        id: "OVHQZTi3eP",
        api: [35],
        subpermissions: {
            LOCALIZATION_TAB_NEW_GROUP: {
                name: 'Create new group',
                message: "Allow to create new group",
                id: "oZYyuhcvqI",
                api: [],
            },
            LOCALIZATION_TAB_EDIT_GROUP: {
                name: 'Edit group',
                message: "Allow to Edit group",
                id: "NGqbMpFJUn",
                api: [],
            },
            LOCALIZATION_TAB_DELETE_GROUP: {
                name: 'Delete group',
                message: "Allow to Delete group",
                id: "X9WSt4xNTX",
                api: [],
            },
            LOCALIZATION_TAB_ADD_KEY_VALUE: {
                name: 'Add key value',
                message: "Allow to add key value",
                id: "m8RF905pNb",
                api: [],
            },
            LOCALIZATION_TAB_EDIT_KEY_VALUE: {
                name: 'Edit key value',
                message: "Allow to edit key value",
                id: "ofScU4jFMk",
                api: [],
            },
            LOCALIZATION_TAB_ADD_MISSING_KEYS: {
                name: 'Add missing keys',
                message: "Allow to add missing keys",
                id: "HHwZCA6oKn",
                api: [3],
            },
            LOCALIZATION_TAB_EXPORT: {
                name: 'Export localization',
                message: "Allow to export localization",
                id: "oM9rmTLnVV",
                api: [19],
            },
        }
    };

    static MAP_TAB = {
        name: 'Map',
        message: "Allow to view Map Tab",
        id: "T7vL0ObPP5",
        api: [6],
        subpermissions: {
            MAP_TAB_IMPORT: {
                name: 'Import tmx files',
                message: "Allow to import tmx files",
                id: "qjLPGpkoyf",
                api: [18],
            },
            MAP_TAB_EXPORT: {
                name: 'Export map',
                message: "Allow to export map",
                id: "WT3wz09dKp",
                api: [9],
            },
            MAP_TAB_DUBLICATE: {
                name: 'Dublicate map',
                message: "Allow to dublicate map",
                id: "ObJJUsPS4Q",
                api: [8],
            },
            MAP_TAB_DELETE: {
                name: 'Delete map',
                message: "Allow to delete map",
                id: "rOPYzQr1d5",
                api: [10],
            },
            MAP_TAB_EDIT_AUD: {
                name: 'Edit Audiences',
                message: "Allow to edit map audiences",
                id: "NkzwwHeaZG",
                api: [13],
            },
            MAP_TAB_EDIT_VER: {
                name: 'Edit Version',
                message: "Allow to edit map version",
                id: "gebBJnVSfW",
                api: [14],
            },
        }
    };

    static PACKAGE_TAB = {
        name: 'Package',
        message: "Allow to view Package Tab",
        id: "7yTWHN8btc",
        api: [42, 40, 41, 43],
        subpermissions: {
            PACKAGE_TAB_DRAFT_VIEW: {
                name: 'View draft view tab',
                message: "Allow to view draft view tab",
                id: "qJFn52E2TT",
                api: [38],
            },
            PACKAGE_TAB_ACTIVE_VIEW: {
                name: 'View active view tab',
                message: "Allow to view active view tab",
                id: "3w74886tGK",
                api: [46],
            },
            PACKAGE_TAB_DR_CREATE_NEW_PACKAGE: {
                name: 'New package',
                message: "Allow to create new package",
                id: "tDZmg5eP6u",
                api: [37],
            },
            PACKAGE_TAB_DR_EDIT_PACKAGE: {
                name: 'Edit package',
                message: "Allow to edut new package",
                id: "652a2EPy4b",
                api: [44],
            },
            PACKAGE_TAB_DR_DELETE_PACKAGE: {
                name: 'Delete package',
                message: "Allow to delete package",
                id: "A5dBMvQAXU",
                api: [39],
            },
            PACKAGE_TAB_DR_ACTIVATE_PACKAGE: {
                name: 'Active package',
                message: "Allow to activate new package",
                id: "bmpZ5PfwRa",
                api: [45],
            },
            PACKAGE_TAB_AC_DELETE_PACKAGE: {
                name: 'Delete deployed package',
                message: "Allow to delete deployed package",
                id: "rwmW5QKTLq",
                api: [48],
            },
            PACKAGE_TAB_AC_SET_VERSION_PACKAGE: {
                name: 'Set version to deployed package',
                message: "Allow to set version to deployed package",
                id: "88vLGVNmwE",
                api: [49],
            },
            PACKAGE_TAB_AC_SET_AUDIENCE_PACKAGE: {
                name: 'Set audiences to deployed package',
                message: "Allow to set audiences to deployed package",
                id: "zvWwjdUr2w",
                api: [47],
            },
        }
    };

    static USERS_TAB = {
        name: 'Users',
        message: "Allow to view Users Tab",
        id: "kb8CUgVark",
        api: [2],
        subpermissions: {
            USERS_TAB_CHANGE_AUD: {
                name: 'Change User Audience',
                message: "Allow to change User Audience",
                id: "9kpV0EBdvH",
                api: [],
            },
            USERS_TAB_EXPORT_SAVE: {
                name: 'Export User Save',
                message: "Allow to export User Save",
                id: "EpDMSsW1w1",
                api: [16],
            },
            USERS_TAB_IMPORT_SAVE: {
                name: 'Import User Save',
                message: "Allow to import User Save",
                id: "MW260uyWdA",
                api: [36],
            },
        }
    };

    static PERMISSION_TAB = {
        name: 'Permissions',
        message: "Allow to view Permissions Tab",
        id: "ujIi0mzaX0",
        api: [33],
        subpermissions: {
            PERMISSION_TAB_EDIT: {
                name: 'Edit Users Permissions',
                message: "Allow to edit users permissions",
                id: "uacW8QP4gY",
                api: [],
            },
        }
    };

    static REDACTOR_TAB = {
        name: 'Redactor',
        message: "Redactor permissions",
        id: "ujIiddzaX0",
        api: [],
        subpermissions: {
            REDACTOR_FULL_ACCESS: {
                name: 'Full Access',
                message: "",
                id: "uacWTGK4gY",
                api: [],
            },
        }
    };

    static APP_PERMISSIONS() {
        return [
            PermissionsStoreUtils.AB_TAB,
            PermissionsStoreUtils.CACHE_TAB,
            PermissionsStoreUtils.CONFIG_TAB,
            PermissionsStoreUtils.DEPLOY_TAB,
            PermissionsStoreUtils.INBOX_TAB,
            PermissionsStoreUtils.INFO_TAB,
            PermissionsStoreUtils.LOCALIZATION_TAB,
            PermissionsStoreUtils.MAP_TAB,
            PermissionsStoreUtils.PACKAGE_TAB,
            PermissionsStoreUtils.USERS_TAB,
            PermissionsStoreUtils.PERMISSION_TAB,
            PermissionsStoreUtils.REDACTOR_TAB
        ]
    }

    static getApiForKey(key) {
        var final = []
        let all = PermissionsStoreUtils.APP_PERMISSIONS()
        for (var a in all) {
            if (all[a].id == key) {
                final = final.concat(all[a].api)
            }
            let subpermissions = all[a].subpermissions;
            for (var s in subpermissions) {
                if (subpermissions[s].id == key) {
                    final = final.concat(subpermissions[s].api)
                }
            }
        }

        return final;
    }

    static getAllApi() {
        var final = []
        let all = PermissionsStoreUtils.APP_PERMISSIONS()
        for (var a in all) {
            final = final.concat(all[a].api)
            let subpermissions = all[a].subpermissions;
            for (var s in subpermissions) {
                final = final.concat(subpermissions[s].api)
            }
        }
        return final;
    }

    static setUserApiPermission(data) {
        return Store.dispatch("permissions-store/setUserApiPermission", data);
    }

    static fethApiPermission() {
        return Store.dispatch("permissions-store/fethApiPermission");
    }

    static fethFrontendUsers() {
        return Store.dispatch("permissions-store/fethFrontendUsers");
    }

    static fethAppPermission() {
        return Store.dispatch("permissions-store/fethAppPermission");
    }

    static setUserAppPermission(uid, permissions) {
        return Store.dispatch("permissions-store/setUserAppPermission", {uid, permissions});
    }

    static fethRegisteredApi() {
        return Store.dispatch("permissions-store/fethRegisteredApi");
    }

    static getUsersPermission() {
        return Store.getters["permissions-store/getUsersPermission"];
    }

    static getAppPermission() {
        return Store.getters["permissions-store/getAppPermission"];
    }

    static getUsers() {
        return Store.getters["permissions-store/getUsers"];
    }

    static getUserName(uid) {
        let users = PermissionsStoreUtils.getUsers()
        if (users == undefined) {
            return uid
        }
        let user = users.find(u => u.uid == uid)
        if (user == undefined) {
            return uid
        }
        return user.email.split("@")[0]
    }

    static getMyName() {
        let uid = PermissionsStoreUtils.getMyUserUid()
        let users = PermissionsStoreUtils.getUsers()
        if (users == undefined) {
            return uid
        }
        let user = users.find(u => u.uid == uid)
        if (user == undefined) {
            return uid
        }
        return user.email.split("@")[0]
    }

    static getMyUserUid() {
        if (firebase.auth().currentUser == null) {
            return ''
        }
        return firebase.auth().currentUser.uid
    }

    static getAllPermission(uid) {
        let allPermisions = PermissionsStoreUtils.getAppPermission();
        if (allPermisions == undefined) {
            return []
        }
        let basePermissions = allPermisions[uid]
        if (basePermissions == undefined) {
            return null
        }
        let permissions = []
        permissions = JSON.parse(JSON.stringify(basePermissions));
        for (var a in permissions.subpermissions) {
            permissions.push(permissions.subpermissions[a])
        }
        return permissions;
    }

    static isDevelopment() {
        return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---development'
    }

    static isProduction() {
        return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---production'
    }

    static getPermission(uid, name) {
        if (uid == "") {
            return false
        }
        if (PermissionsStoreUtils.getMyUserUid() == '7DxT9awtbIRFSEYzsH9HEJt5a5r1') {
            //return true
        }
        let all = PermissionsStoreUtils.getAllPermission(uid)
        if (all == undefined) {
            return false
        }
        if (all[name] == undefined) {
            return false
        }
        return all[name];
    }

}